import React from 'react';

import './WpModalFooter.scss';

export interface Props {
  children?: React.ReactNode;
}

const classNamePrefix = 'WpModalFooter';

const WpModalFooter: React.FC<Props> = ({ children }: Props) => <div className={classNamePrefix}>{children}</div>;

export default WpModalFooter;
